export const useTabMeta = <T>(name: string) => {
  const { $site } = useNuxtApp()
  const route = useRoute()

  const tab = computed(() => {
    
    if (name) {
      return $site.tabs[name]
    }

    const item = route.meta.tabs?.[0]
  
    if (item) {
      return $site.tabs[item]
    }
  })
  
  const title = computed(() => {
    if (tab?.value?.name) {
      const name = tab.value.name
  
      if (name) {
        return `${name} - ${$site.location.title}`
      }
    }
  
    return $site.location.title
  })
  
  const description = computed(() => {
    if (tab.value) {
      return tab.value.information
    }
  
    return $site.settings?.bookappDescription
  })


  useSeoMeta({
    title: () => title.value,
    ogTitle: () => title.value,
    description: () => description.value,
    ogDescription: () => description.value,
  })
}